class SoflyDigitalConsent extends HTMLElement {
  connectedCallback() {
    this.inputs = [...this.querySelectorAll('input[type=checkbox]')];
    this.input = this.inputs[0];
    this.accepted = () => this.inputs.length === 1 && this.input.checked;
    this.status = this.querySelector('[role="status"]');
    this.form = document.getElementById(this.dataset.form);
    this.button = document.querySelector(`[name="checkout"][form="${this.dataset.form}"]`);
    if (!this.form || !this.button) return;
    this.busy = false;
    this.saved = false;
    this.inputs.forEach(input => { input.checked = false; });
    this.sync = () => {
      this.button.disabled = this.button.dataset?.releaseBlocked === 'true' || !this.accepted() || this.busy;
      this.status.textContent = this.button.dataset?.releaseBlocked === 'true' ? 'This cart contains an unreleased product. Remove it to continue.' : '';
    };
    this.inputs.forEach(input => input.addEventListener('change', this.sync));
    this.submit = async (event) => {
      if (event.target !== this.form || event.submitter?.name !== 'checkout') return;
      if (this.button.dataset?.releaseBlocked === 'true') { event.preventDefault();this.sync();return; }
      if (this.saved && this.accepted()) { this.saved = false; return; }
      event.preventDefault();
      if (!this.accepted()) { this.input.reportValidity(); return; }
      if (this.busy) return;
      this.busy = true;
      this.sync();
      this.status.textContent = 'Saving your choices...';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'User terms v1.0.1': 'Accepted', 'Digital supply request v1.0.0': 'Requested', 'Withdrawal acknowledgement v1.0.0': 'Acknowledged' } })
        });
        if (!response.ok) throw new Error('Acknowledgement was not saved');
        const cart = await response.json();
        if (!this.isConnected || !this.accepted() || this.button.dataset?.releaseBlocked === 'true') return;
        if (document.querySelector('[data-turbine-checkout="191169790280"]')) {
          if (!window.soflyCheckout) throw new Error('Account checkout is unavailable');
          this.status.textContent = 'Connecting to your SoFly account…';
          await window.soflyCheckout.begin(cart);
          return;
        }
        this.saved = true;
        this.button.disabled = false;
        this.form.requestSubmit(this.button);
      } catch (_) {
        this.status.textContent = 'We could not save your acknowledgement. Please try checking out again.';
      } finally {
        this.busy = false;
        this.button.disabled = this.button.dataset?.releaseBlocked === 'true' || !this.accepted();
      }
    };
    document.addEventListener('submit', this.submit, true);
    this.sync();
  }
  disconnectedCallback() {
    document.removeEventListener('submit', this.submit, true);
    this.inputs?.forEach(input => input.removeEventListener('change', this.sync));
  }
}
customElements.define('sofly-digital-consent', SoflyDigitalConsent);

class SoflySocialClubConsent extends HTMLElement {
  connectedCallback() {
    const choice = window.soflyCheckout?.socialClubChoice();
    if (choice !== undefined) this.querySelector('[data-social-club-opt-in]').checked = choice;
  }
}
customElements.define('sofly-social-club-consent', SoflySocialClubConsent);

class SoflyStickyProduct extends HTMLElement {
  connectedCallback() {
    this.product = document.getElementById(`MainProduct-${this.dataset.section}`);
    this.original = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
    if (!this.product || !this.original) return;
    this.button = this.querySelector('[data-sticky-add]');
    this.price = this.querySelector('[data-sticky-price]');
    this.status = this.querySelector('[data-sticky-status]');
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.sync = () => {
      // Dawn replaces the purchase controls when the selected variant changes.
      this.original = document.getElementById(`ProductSubmitButton-${this.dataset.section}`) || this.original;
      const sourcePrice = document.getElementById(`price-${this.dataset.section}`);
      const copy = sourcePrice?.cloneNode(true);
      copy?.querySelectorAll('[data-blade-instance]').forEach(el=>el.removeAttribute('data-blade-instance'));
      const html = sourcePrice?.classList.contains('hidden') ? '' : (copy?.innerHTML || '');
      if (this.priceSnapshot !== html) { this.priceSnapshot=html; this.price.innerHTML=html; }
      this.price.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      this.button.disabled = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true';
      this.button.textContent = this.original.classList.contains('loading') ? 'Addingâ€¦' : this.original.querySelector('span')?.textContent.trim();
      this.status.textContent = this.product.querySelector('.product-form__error-message')?.textContent || '';
      const edition = this.querySelector('[data-sticky-options]');
      if (edition) edition.textContent = [...this.product.querySelectorAll('variant-selects input:checked, variant-selects select')].map(el => el.value).join(' / ');
      this.visibility();
    };
    this.visibility = () => {
      // Shopify's transparent preview iframe covers the entire viewport. Reserve
      // space for its bottom toolbar, never use the iframe's full-screen height.
      this.style.bottom = document.getElementById('PBarNextFrame') ? '76px' : '0px';
      this.hidden = this.product.dataset.sfOwned === 'true' || this.original.getBoundingClientRect().bottom >= 0 || !!document.querySelector('cart-drawer.active, cart-notification.active, details[open] .menu-drawer, product-modal[open], .sf-wishlist-dialog[open], .sf-wishlist-panel:popover-open, .shopify-pc__banner__dialog');
      document.documentElement.classList.toggle('sf-sticky-buy-visible', !this.hidden);
    };
    this.button.addEventListener('click', () => {
      if (!this.button.disabled) this.original.click();
    }, options);
    this.observer = new MutationObserver(this.sync);
    this.observer.observe(this.product, { subtree: true, childList: true, attributes: true, characterData: true });
    this.drawerObserver = new MutationObserver(this.visibility);
    document.querySelectorAll('cart-drawer, cart-notification, header-drawer, product-modal').forEach((element) => this.drawerObserver.observe(element, { attributes: true, subtree: true, attributeFilter: ['class', 'open'] }));
    window.addEventListener('scroll', this.visibility, { ...options, passive: true });
    window.addEventListener('resize', this.visibility, options);
    document.getElementById('SoFlyWishlistPanel')?.addEventListener('toggle', this.visibility, options);
    this.sync();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.drawerObserver?.disconnect();
    document.documentElement.classList.remove('sf-sticky-buy-visible');
  }
}
customElements.define('sofly-sticky-product', SoflyStickyProduct);
